import { setStringAsync } from "@-/com.npmjs.expo-clipboard";
import { toast } from "@-/com.npmjs.sonner";

export type CopyToClipboardOptions = {
  /**
   * What was copied, used to build the toast message (e.g. `"Secret key"` →
   * `"Secret key copied."`). When omitted, a generic `"Copied to clipboard."`
   * toast is shown instead.
   */
  label?: string;
  /** Disable when the caller provides inline success feedback. */
  showSuccessToast?: boolean;
};

/**
 * The single entry point for writing to the clipboard. Every copy in the app
 * MUST go through here so success feedback is consistent — never call
 * `setStringAsync` / `Clipboard.setStringAsync` directly.
 *
 * Writes `value` to the system clipboard and, on success, fires a sonner toast.
 * Pass `label` to describe what was copied; otherwise a generic message is used.
 */
export async function copyToClipboard(
  value: string,
  { label, showSuccessToast = true }: CopyToClipboardOptions = {},
): Promise<void> {
  await setStringAsync(value);
  if (showSuccessToast) {
    toast.success(label == null ? "Copied to clipboard." : `${label} copied.`);
  }
}
